module.exports = __webpack_public_path__ + "media/images/countryrect/sj-47ab8043985e5c93a43d5d56a0deb225.svg";